import controller from './tabs.controller';

const template = require('./tabs.html');

export default {
    bindings: {
        selectedTabId: '=?',
        tabs: '<',
        onTabClick: '&',
        onTabSelect: '&',
        onTabDeselect: '&',
        onTabMenuItemClick: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/common/navbar/tabs/tabs.component.js